import { render, staticRenderFns } from "./BundleGroup.vue?vue&type=template&id=73f549e5&scoped=true&"
import script from "./BundleGroup.vue?vue&type=script&lang=js&"
export * from "./BundleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f549e5",
  null
  
)

export default component.exports